import type { ReactNode } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ProfileSettingsPanel } from '~/features/settings/ProfileSettingsPanel';

// Settings → Profile. The session this panel reads is already warmed by the
// `_protected` auth gate, so no per-route loader is needed.
export const Route = createFileRoute('/_protected/settings/profile')({
  component: SettingsProfileRoute,
});

function SettingsProfileRoute(): ReactNode {
  return <ProfileSettingsPanel />;
}
